export default __webpack_public_path__ + "static/dairy-free-collection-caramel-macadamia-c64cac99072fbfc4ac02c11db46ab9f8.png";